import {TreeViewItem} from '../@types/tree-view-item';
import {getPathToRootAsArrayOfString, role} from './group-utils';
import {BreadCrumbsProp} from '../@types/bread-crumb';
import {getResourceNameWithAscendants} from './resource-utils';
import {ResourceType} from '../@types/resource-type';
import Occurrence from '../@types/occurrence';



export function occurrenceTreeItems(occurrences: Occurrence[]): TreeViewItem[] {    
    return occurrences.map((oc: Occurrence) => occurrenceTreeItem(oc, role(oc.group),
        getResourceNameWithAscendants(oc.group, ResourceType.GROUPS)))
}

const occurrenceTreeItem = (occurrence: Occurrence, role: string, path: string): TreeViewItem => {
    // const locationSymbol = String.fromCodePoint(0x1F4CC);
    // const datetimeSymbol = String.fromCodePoint(0x1F4C5);
    return {
        id: occurrence.id!.toString(),
        object: occurrence,
        // name: `${occurrence.displayName} (${datetimeSymbol} ${new Date(occurrence.dateTime).toLocaleDateString()}) - (${locationSymbol} ${occurrence.location.name})`,
        name: `${occurrence.displayName}`,
        location: occurrence.location.name,
        dateTime: occurrence.dateTime,
        groupPath: path,
        groupRole: role,
        type: ResourceType.OCCURRENCE_REPORTS,
        hasChildren: false,
        sortField: occurrence.dateTime
    };
}

export function makeOccurrence(occurrence: any): Occurrence {
    let occur: Occurrence = {} as Occurrence;
    occur.id = occurrence.id;
    occur.uniqueId = occurrence.uniqueId;
    occur.displayName = occurrence.displayName;
    occur.dateTime = occurrence.dateTime;
    occur.location = occurrence.location;
    occur.created = occurrence.created;
    occur.occurrenceSource = occurrence.occurrenceSource;
    occur.occurrenceType = occurrence.occurrenceType;
    occur.rawReport = occurrence.rawReport;
    occur.group = occurrence.group;
    return occur;
}

export function getOccurrencePathToRootAsArrayOfString(occurrence: Occurrence): Array<BreadCrumbsProp> {
    let path: Array<BreadCrumbsProp> = [];
    if (occurrence.id) {
        path = getPathToRootAsArrayOfString(occurrence.group);
    }

    return [...path, {
        id: occurrence.id,
        label: occurrence.displayName && occurrence.displayName !== '' ? occurrence.displayName : 'New Occurrence Report',
        type: ResourceType.OCCURRENCE_REPORTS}];
}
